module.exports = __webpack_public_path__ + "static/img/gir-info.e814b6d3.png";